import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next",
  "use": "next-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"next\"><title>1D0BCFB7-435A-42DE-98CF-F220B0ECB770</title><path d=\"M7 6c0 .199-.088.398-.265.55l-5.071 4.352a.435.435 0 0 1-.55 0 .3.3 0 0 1 0-.471l5.071-4.353a.101.101 0 0 0 0-.157L1.114 1.57a.3.3 0 0 1 0-.471.435.435 0 0 1 .55 0L6.735 5.45A.724.724 0 0 1 7 6\" stroke=\"#552373\" stroke-width=\"2\" fill=\"#562672\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol